import { Add } from '@carbon/icons-react';
import { Button, Fade, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

type Props = {
    addWidget: () => void;
};

const AddWidgetButton = ({ addWidget }: Props) => {
    const classes = useStyles();
    const [t] = useTranslation();
    const handleAddWidgetClick = () => {
        addWidget();
    };

    return (
        <Tooltip
            classes={{
                tooltip: classes.tooltip,
            }}
            title={t('COMMON.WIDGET_ADD_TOOLTIP')}
            placement="left-start"
            TransitionComponent={Fade}
            data-testid="add-widget-button"
            arrow
        >
            <Button color="primary" className={classes.headerButton} size="medium" onClick={handleAddWidgetClick} variant="contained">
                <Add />
            </Button>
        </Tooltip>
    );
};

export default AddWidgetButton;
